import { apiClient } from "./client";

export interface RouteWaypoint {
  lat: number;
  lng: number;
}

export interface RouteResult {
  distance_km: number;
  duration_min: number;
  /** Coppie [lat, lng] già nell'ordine giusto per <Polyline positions={...}>. */
  geometry: [number, number][];
}

export interface TripResult extends RouteResult {
  /** Indici (nell'array di waypoints inviato) nell'ordine di visita ottimale. */
  order: number[];
}

/** Percorso stradale che collega i waypoint nell'ordine in cui sono passati. */
export async function calculateRoute(waypoints: RouteWaypoint[]): Promise<RouteResult> {
  const { data } = await apiClient.post<RouteResult>("/routing/route", { waypoints });
  return data;
}

/** Giro ottimale (TSP) a partire dal primo waypoint (il Centro Assistenza). */
export async function calculateTrip(waypoints: RouteWaypoint[], roundtrip = false): Promise<TripResult> {
  const { data } = await apiClient.post<TripResult>("/routing/trip", { waypoints, roundtrip });
  return data;
}
